import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all stockItemses
export const getStockItemses = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/stock-items`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching stock-items:", error.response?.data || error);
    throw error;
  }
};

// GET a single stockItems
export const getStockItemsById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/stock-items/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching stock-items:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new stockItems
export const createStockItems = async (stockItemsData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/stock-items`, stockItemsData);
    return response.data;
  } catch (error) {
    console.error("Error creating stock-items:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing stockItems
export const updateStockItems = async (id, stockItemsData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/stock-items/${id}`, stockItemsData);
    return response.data;
  } catch (error) {
    console.error("Error updating stock-items:", error.response?.data || error);
    throw error;
  }
};

// DELETE a stockItems
export const deleteStockItems = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/stock-items/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting stock-items:", error.response?.data || error);
    throw error;
  }
};

export const getNextStockItemNumber = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/stock-items/next-material-number`);
    return response.data;
  } catch (error) {
    console.error('Error fetching next stock item number:', error.response?.data || error);
    throw error;
  }
};

export const getWarehouseStockForWorkOrder = async (stockItemId, workOrderId) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/stock-items/${stockItemId}/warehouse-stock-for-work-order/${workOrderId}`,
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching warehouse stock for work order:', error.response?.data || error);
    throw error;
  }
};
